import Modal from "../_bootstrapModalExtensions";
import NotificationUtil from "../_notificationUtil"
import * as Url from "../Utils/UrlUtil";
import { Interfaces } from "../_interfaces";
import Classes from "../_classes";

export let IsCallbackPendingOnDocumentList: boolean = false;

var type;
var beginCallbackEventHandlerAttached: boolean = false;
var activeTabchangingEventHandlerAttached: boolean = false;
let isUploadedDocsInit: boolean;

// dokumentumok lapon a kijelölés változást figyeli
export function DocumentListSelectionChanged(s: MVCxClientGridView, e) {
    var keys = s.GetSelectedKeysOnPage();

    if (keys != null) {
        var deleteButton = $('#massoperation-delete-button');
        if (keys.length > 0) {
            deleteButton.removeAttr("disabled");
        } else {
            deleteButton.attr("disabled", "disabled");
        }
    }
}

export function DocumentListOnlyAllowFocusInEditableColumns(s: MVCxClientGridView, e: ASPxClientGridViewFocusedCellChangingEventArgs): void {
    // This prevents the behavior when cancelling this event the grid scrolls up to the top
    if (isUploadedDocsInit) {
        isUploadedDocsInit = false;

        return;
    }

    var column = e.cellInfo.column;

    if (column.fieldName !== 'OrderNumber' && column.fieldName !== 'TypeAndDescription') {
        e.cancel = true;
    }
}

export function StartEditRow(gridName: string, e: ASPxClientGridViewBatchEditStartEditingEventArgs) {
    window.setTimeout(function () {
        $('.document-action-button').removeAttr('disabled');
    }, 0);
    type = '';

    let grid = window[gridName] as MVCxClientGridView;

    var templateColumn = grid.GetColumnByField('TypeAndDescription');
    if (!e.rowValues.hasOwnProperty(templateColumn.index)) {
        return;
    }

    if (e.focusedColumn.fieldName == 'TypeAndDescription') {
        var cellInfo = e.rowValues[templateColumn.index];

        if (cellInfo && cellInfo.value) {
            var firstOccurence = cellInfo.value.toString().search('\\|');

            if (firstOccurence > 0) {
                var tempCellValue = cellInfo.value.toString();
                cellInfo.value = tempCellValue.substring(firstOccurence + 1, tempCellValue.length).trim();
                type = tempCellValue.substring(0, firstOccurence - 1).trim();
            }
        }
    }
}

export function InitEditIcon(element: Element, gridName: string) {
    event.stopPropagation()
    event.preventDefault();

    let grid = window[gridName] as MVCxClientGridView;
    let rowId = $(element).data("rowid");

    grid.StartEditRow(rowId);
}

export function EndEditRow(gridName: string, e: ASPxClientGridViewBatchEditEndEditingEventArgs) {
    let grid = window[gridName] as MVCxClientGridView;

    var templateColumn = grid.GetColumnByField('TypeAndDescription');
    if (!e.rowValues.hasOwnProperty(templateColumn.index)) {
        return;
    }

    var cellInfo = e.rowValues[templateColumn.index];

    // Cella szerkesztés után a típus nem látszódna a szerkesztett cellában az oldal újratöltéséig, ezért ezt itt újra beszúrjuk a megjegyzés elé.
    if (type) {
        if (cellInfo.value) {
            cellInfo.value = type + ' | ' + cellInfo.value;
        }
        else {
            cellInfo.value = type + ' | ';
        }

        cellInfo.text = cellInfo.value;
    }

    SaveEditChanges(grid);
}

export function SaveEditChanges(s: ASPxClientGridView): void {
    s.batchEditApi.EndEdit();

    setTimeout(() => {
        if (s.batchEditApi.HasChanges()) {
            let changes = GetEditChanges();

            $.ajax({
                type: 'POST',
                contentType: "application/json",
                dataType: 'json',
                url: window.ETDR_RD.appConfig["UrlAction.UpdateDocumentProperties"],
                data: JSON.stringify(changes)
            }).done(() => {
                resetEditedGridCellBackground();

                addCustomEventhandlersToHandleAutoSave(changes);
            }).catch((e) => {
                NotificationUtil.Error('A változásokat nem sikerült elmenteni!');
            });
        }
    }, 0);
}

function addCustomEventhandlersToHandleAutoSave(changes: Array<object>): void {
    let grid: ASPxClientGridView = window['uploadedDocs'] as ASPxClientGridView;
    if (!beginCallbackEventHandlerAttached) {
        grid.BeginCallback.AddHandler(() => {
            setTimeout(() => {
                resetEditedGridCellBackground();
            }, 500);
        });

        beginCallbackEventHandlerAttached = true;
    }

    // For some reasons (that i haven't figured out) tab changing will not the already running SaveEditChanges()'s visual changes to take effect. Calling it again will solving this problem.
    let pageControl: ASPxClientPageControl = window['processEdit'] as ASPxClientPageControl || window['processActionEdit'] as ASPxClientPageControl;
    if (!activeTabchangingEventHandlerAttached) {
        pageControl.ActiveTabChanging.AddHandler(() => {
            SaveEditChanges(grid);
            RefreshDocumentList();
        });

        activeTabchangingEventHandlerAttached = true;
    }
}

function resetEditedGridCellBackground(): void {
    $('.dxgvBatchEditModifiedCell').attr('style', 'background-color: Transparent').removeClass('dxgvBatchEditModifiedCell');
}

function GetEditChanges(): Array<object> {
    let grid = window['uploadedDocs'] as MVCxClientGridView;
    let changes: Array<object> = [];

    for (let i = 0; i < grid.GetVisibleRowsOnPage(); i++) {
        if (HasChanges(grid, i)) {
            let rowKey = grid.GetRowKey(i).split('|');
            let orderNumber = grid.batchEditApi.GetCellValue(i, 'OrderNumber', false);

            if (!orderNumber) {
                grid.batchEditApi.SetCellValue(i, 'OrderNumber', '0');
            }

            let temp: object = grid.batchEditApi.GetCellValue(i, 'TypeAndDescription', false);
            let typeAndDescription: string = !temp ? '' : temp.toString();

            let tempArray: Array<string> = typeAndDescription.includes('|') ? typeAndDescription.split('|') : null;
            let description: string;

            if (tempArray) {
                tempArray.shift();
                description = tempArray.length > 1 ? tempArray.join('|') : tempArray[0];
            }
            else {
                description = typeAndDescription;
            }

            changes.push({
                orderNumber: orderNumber,
                typeAndDescription: description,
                documentId: rowKey[0]
            });
        }
    }

    return changes;
}

function HasChanges(grid: MVCxClientGridView, index: number): boolean {
    if (grid.batchEditApi.GetCellValue(index, 'OrderNumber', false) != grid.batchEditApi.GetCellValue(index, 'OrderNumber', true) ||
        grid.batchEditApi.GetCellValue(index, 'TypeAndDescription', false) != grid.batchEditApi.GetCellValue(index, 'TypeAndDescription', true)) {

        return true;
    }
}

export function SaveChangesOnBeforeUnload(): void {
    window.onbeforeunload = () => {
        let grid: ASPxClientGridView = window['uploadedDocs'] as ASPxClientGridView;
        SaveEditChanges(grid);
    }
}

export function InitDetailRowCustomButtons() {
    $(document).on("click", ".document-details-button-showDetails", (event) => {
        let $element = $(event.target);
        let visibleIndex = $element.data("visibleindex");

        let grid = window['uploadedDocs'] as MVCxClientGridView;
        grid.ExpandDetailRow(visibleIndex);
    });

    $(document).on("click", ".document-details-button-hideDetails", (event) => {
        let $element = $(event.target);
        let visibleIndex = $element.data("visibleindex");

        let grid = window['uploadedDocs'] as MVCxClientGridView;
        grid.CollapseDetailRow(visibleIndex);
    });
}

export function MakeDocumentDownloadLinks(sender: MVCxClientGridView, _: ASPxClientEventArgs) {
    let grid = sender as Interfaces.MVCxClientGridViewWithCustomProperties;

    var dLoadObj: any = {
        processNumber: $('#procinfo-section').data('processnumber'),
        docList: grid.cpDownloadDocData
    }

    $('#document-list-for-download').attr('data-dload-object', JSON.stringify(dLoadObj));
}

export function DeleteAttachedDocuments(name: string, requestUrl: string, redirectUrl: string, processActionid: number) {
    let grid: Interfaces.MVCxClientGridViewWithCustomProperties = window[name] as Interfaces.MVCxClientGridViewWithCustomProperties;
    var allKeys = grid.cpAllKeysOnPage.split(',');
    var unSelectedKeys = allKeys.filter(k => !grid.GetSelectedKeysOnPage().includes(k));

    unSelectedKeys = unSelectedKeys.map(function (elem) {
        return elem.split('|')[0];
    });

    var request = $.ajax({
        method: "POST",
        url: requestUrl,
        traditional: true,
        data: {
            selectedItems: unSelectedKeys,
            processActionId: processActionid
        }
    });

    request.done(function (msg) {
        (grid as any).ShowLoadingPanel();
        window.location.href = redirectUrl;
    });

    request.fail(function (msg) {
        (grid as any).ShowLoadingPanel();
        Modal.showAlertWindow('A dokumentumok mentése sikertelen!', 'Hiba');
    });
}

// Erre a függvényre azért van szükség, mert a batchEdit-es tab-os focus váltás miatt nem fókuszálható cella esetén eldobjuk a focust.
// Mivel emiatt nem létezik fókuszált cella, a devexpress magától focus-olja az első cellát.
// Ez gyakran azután történik, hogy a felhasználó már legörgetett a táblázatban.
// Ezzel a lépéssel a görgetés előtt adunk neki egy focust, hogy a devexpress ne szopasson meg minket.
export function FocusFirstCell() {
    let grid = window['uploadedDocs'] as MVCxClientGridView;
    grid.SetFocusedCell(0, 0);
}

export function DocumentlistOnBeginCallback(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    let isHiddenDocumentFilterActive: boolean = false;
    isHiddenDocumentFilterActive = window.SettingsManager.getAttribute('FilterForHiddenDocuments') as boolean;

    e.customArgs['isHiddenDocumentFilterActive'] = isHiddenDocumentFilterActive;

    IsCallbackPendingOnDocumentList = true;
}

export function DocumentlistOnEndCallback() {
    IsCallbackPendingOnDocumentList = false; 
}

export function DocumentListOnInit() {
    $('#hidden-documents-display-switch').click((event: JQuery.TriggeredEvent) => { OnHiddenDocumentDisplaySwitchClicked(event) });
    $('#documentlist-refresh-btn').click(() => { RefreshDocumentList() });

    isUploadedDocsInit = true;
}

export function OnHiddenDocumentDisplaySwitchClicked(event: JQuery.TriggeredEvent) {
    let switchValue: boolean = $(event.target).prop('checked') as boolean;

    window.SettingsManager.setAttribute('FilterForHiddenDocuments', switchValue);

    RefreshDocumentList();
}

export function RefreshDocumentList() {
    let grid = window['uploadedDocs'] as MVCxClientGridView;

    grid.Refresh();
}

export function SetHiddenDocumentFilterSwitchPosition() {
    let $filterSwitch: JQuery = $('#hidden-documents-display-switch');

    // If not at the right location, do nothing
    if ($filterSwitch.length === 0) {
        return;
    }

    let savedSwitchposition: boolean = false;
    savedSwitchposition = window.SettingsManager.getAttribute('FilterForHiddenDocuments') as boolean;

    $filterSwitch.prop('checked', savedSwitchposition);
}

export function OnEkozmuQueryBtnClick(event: JQuery.ClickEvent): void {
    var template = window.ETDR_RD.appConfig['UrlAction.GetAttachEkozmuStatementForm'];
    let processActionId = $(event.target).data('processactionid');
    const ekozmuModalSettings: Classes.BootstrapModalWithAjaxContentSettings = GetEkozmuModalSettings();
    Modal.showBootstrapModalWithAjaxContent(ekozmuModalSettings);

    function GetEkozmuModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'E-közmű dokumentum megadása';
        settings.contentUrl = Url.createUrlFromTemplate(template, { processActionId: processActionId });
        settings.saveUrl = window.ETDR_RD.appConfig['UrlAction.PostAttachEkozmuStatementForm'];
        settings.callback = data => callback(data);
        settings.enableUnobtrusiveValidation = true;
        settings.infoText = 'Mindkét azonosítót megtalálja az E-közmű alkalmazásból származó dokumentum "Kérelem alapadatai" blokkjában. A Dokumentum azonosítót az "Azonosító" mezőben, a NÜJ-t pedig a "Kérelmező neve" mezőben, zárójelek között találja.';
        settings.canSaveUsingEnterKey = true;

        return settings;
    }

    function callback(data): void {
        if (data && data.success) {
            let gridView = window['uploadedDocs'] as MVCxClientGridView;
            gridView.Refresh();

            NotificationUtil.Info('Az e-közmű dokumentum hozzáadása sikeres.', 'E-közmű nyilatkozat');
        } else {
            NotificationUtil.Error('Hiba történt az e-közmű dokumentum hozzáadása közben.', 'E-közmű nyilatkozat');
        }
    }
}

export function DownloadDocument(id, guid) {
    let urlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.DownloadDocument"];
    let url: string = Url.createUrlFromTemplate(urlTemplate, { id: id, guid: guid });

    location.href = url;
}

export function DownloadDocumentOnDoubleClick(s, e) {
    let rowKey: string = s.GetRowKey(e.visibleIndex);
    let rowKeyAsArray: string[] = rowKey.split('|');
    let rowId: string = rowKeyAsArray[0];
    let rowGuid: string = rowKeyAsArray[1];

    DownloadDocument(rowId, rowGuid);
}

export function DownloadDocumentOnDownloadIconClick(gridName: string) {

    let grid: MVCxClientGridView = window[gridName] as MVCxClientGridView;

    // Get the selected keys as an array (["<id>|<guid>", "<id>|<guid>", ...]
    let selectedKeys: Object[] = grid.GetSelectedKeysOnPage();

    if (selectedKeys.length === 0) {
        // Nothing is selected (the button should be disabled), do not report any error
        return;
    }
    else if (selectedKeys.length === 1) {
        let rowKeys: string = selectedKeys[0] as string;
        let rowKeyAsArray: string[] = rowKeys.split('|');
        let rowId: string = rowKeyAsArray[0];
        let rowGuid: string = rowKeyAsArray[1];

        DownloadDocument(rowId, rowGuid);
    }
    else {
        // Currently, downloading more than one file is not possible
        // Since the button should be disabled in this case, do not report any error
        return;
    }
}

export function BulkDeleteDocument() {
    let grid: MVCxClientGridView = window['uploadedDocs'] as MVCxClientGridView;

    let selectedRowsKeys: Object[] = grid.GetSelectedKeysOnPage();

    if (selectedRowsKeys.length > 0) {
        Modal.showConfirmationWindowAsync(
            'Biztosan törölni szeretné a a fájlokat?',
            'Megerősítés',
            () => { BulkDeleteDocumentsInternal(selectedRowsKeys); },
            () => { return false; },
            'Igen',
            'Nem');
    }
}

function BulkDeleteDocumentsInternal(selectedRowsKeys: Object[]) {
    let url: string = window.ETDR_RD.appConfig['UrlAction.BulkDelete'];

    $.ajax({
        url: url,
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: "json",
        data: JSON.stringify(selectedRowsKeys),
        headers: { Accept: 'application/json' }
    })
        .done((data: Interfaces.JsonResponseWithResult) => {
            if (data.success) {
                NotificationUtil.Info('A dokumentumok törlése sikeres.');
            }
            else {
                NotificationUtil.Error(data.message);
            }
        })
        .fail((jqXHR: JQueryXHR) => {
            NotificationUtil.Error('Hiba történt a dokumentumok törlése során.');
        })
        .always(() => {
            let grid: MVCxClientGridView = window['uploadedDocs'] as MVCxClientGridView;

            grid.Refresh();
        });
}


$(() => {
    $(document).on('click', '#ekozmu-query-btn', (event: JQuery.ClickEvent) => OnEkozmuQueryBtnClick(event));
});
